import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accentColor", "children", "onClick"];
import styled, { css } from 'styled-components';
import { getCanReadTextOnce } from 'visitor-ui-component-library/utils/colors';
import { EERIE, OBSIDIAN, SLINKY, WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_PROMPT_BUTTON_WIDTH = 384;
const promptButtonBaseStyles = css(["display:inline-flex;align-items:center;max-width:", "px;width:max-content;padding:7px 10px;border-radius:10px;font-weight:600;font-size:12px;line-height:18px;text-align:left;box-sizing:border-box;word-break:break-word;transition:color 0.2s ease,border-color 0.2s ease;"], MAX_PROMPT_BUTTON_WIDTH);
const QuickReplyButtonStyled = styled.button.withConfig({
  displayName: "QuickReplyButton__QuickReplyButtonStyled",
  componentId: "hl9c3k-0"
})(["", " background:", ";color:", ";border:1px solid ", ";cursor:pointer;&:hover:not(:disabled){color:", ";border-color:", ";}&:disabled{opacity:0.6;cursor:not-allowed;}"], promptButtonBaseStyles, WHITE, OBSIDIAN, EERIE, ({
  $accentColor
}) => $accentColor || SLINKY, ({
  $accentColor
}) => $accentColor || SLINKY);
const QuickReplyButton = _ref => {
  let {
      accentColor,
      children,
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isTextReadable = getCanReadTextOnce(accentColor);
  const accessibleAccentColor = isTextReadable ? accentColor : OBSIDIAN;
  return /*#__PURE__*/_jsx(QuickReplyButtonStyled, Object.assign({
    $accentColor: accessibleAccentColor,
    onClick: onClick
  }, props, {
    children: children
  }));
};
QuickReplyButton.displayName = 'QuickReplyButton';
export default QuickReplyButton;